<template>
<div>
    <div v-if='loading && showLoader' class='tc pt2 pb2'>
          <i class="fa fa-spinner fa-pulse fa-2x fa-fw"></i>
    </div>
    <div v-show='!loading' ref="htmlcontent"></div>
    </div>
</template>


<script>

   export default {
    data () {
        return {
            loading: false,
            post: null,
            error: null,
        }
    },

    props:{
        url:{
            default:null,
        },
        showLoader:{
            default:true,
        }
    },

    created () {
        this.fetchData();
    },

    watch: {
        // call again the method if the route changes
        '$route':function (to, from) {
            this.fetchData();
        },
    },



    methods: { 

        fetchData () {

            this.error = this.post = null;
            this.loading = true;
            var url;
            
            
            
            if(this.url.indexOf('http') == -1){
                url =  `${window.API.apiurl}htmls/_generated/${this.$store.getters.currentLang}/${this.url}?v=2`;  //`${window.API.server}${this.$store.getters.currentLang}/${this.url}`;
            }else{
                url =  this.url;
            }
            var finalUrl = url.replace('http://','https://');
            if(!finalUrl.includes('?') && !finalUrl.endsWith('/')) {
                finalUrl += '/';
            }
            $.ajax({
                type: "get",
                url: finalUrl,
                dataType: "html",
                success:  (response)=> {
                    this.loading = false
                    this.post = this.parseHtml(response);
                    this.$emit('loaded')
                },
                error: (err)=>{
                        this.error = err.toString();
                        this.post = "Ocorreu um Erro!!!"
                        this.$emit('loaded')
                        this.$emit('error')
                },
            });
        },

        parseHtml:function(html){
                var htmlFinal = html.replace(/\/remote\//g,`${window.API.server}remote/`); //converto as imagens
                this.$nextTick(()=>{
                    $(this.$refs.htmlcontent).html(htmlFinal);
                })
        }


    }
    }

</script>


<style lang="stylus">
    @import "./../css/variaveis"
  


</style>
